'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createTracker = require('./utils/createTracker');

var _createTracker2 = _interopRequireDefault(_createTracker);

var _snowplowConfigs = require('./utils/snowplowConfigs');

var _trackEvent = require('./utils/trackEvent');

var _constants = require('./utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InsightsModuleSnowplowTracker = function () {
  function InsightsModuleSnowplowTracker(config) {
    _classCallCheck(this, InsightsModuleSnowplowTracker);

    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
    this.__type = 'InsightsModuleSnowplowTracker';

    var globalSnowplowName = config.globalSnowplowName,
        trackerName = config.trackerName,
        trackerConfigKey = config.trackerConfigKey,
        userId = config.userId,
        teamId = config.teamId;


    this.globalSnowplowName = globalSnowplowName;
    this.userId = userId;
    this.teamId = teamId;

    var trackerSettings = trackerConfigKey === 'PROD' ? _snowplowConfigs.defaultConfigs.PROD : _snowplowConfigs.defaultConfigs.TEST;

    (0, _createTracker2.default)(globalSnowplowName, userId, trackerName, trackerSettings);
  }

  _createClass(InsightsModuleSnowplowTracker, [{
    key: 'trackInsightsModuleAction',
    value: function trackInsightsModuleAction(context, action, movedFrom, movedTo, cardName, layoutPosition) {
      var event = {
        schema: _constants.UNIFIED_PRODUCT_INSIGHTS_MODULE_EVENT_SCHEMA,
        data: {
          action: action,
          moved_from: movedFrom,
          moved_to: movedTo,
          card_name: cardName,
          layout_position: layoutPosition,
          user_id: this.userId,
          team_id: this.teamId,
          user_role: context.data.role
        }
      };

      (0, _trackEvent.trackCustomEvent)(this.globalSnowplowName, event, context);
    }
  }, {
    key: 'destructor',
    value: function destructor() {
      this.instance = null;
    }
  }]);

  return InsightsModuleSnowplowTracker;
}();

exports.default = InsightsModuleSnowplowTracker;
module.exports = exports['default'];